import queries from '@apis/queries';
import useUser from '@hooks/auth/useUser';
import { useQuery } from '@tanstack/react-query';

function useCart(shopId: string) {
    const { user } = useUser();
    const { data: cartIdResponse, status, isFetching: idFetching } = useQuery({
        ...queries.cart.cartId(shopId),
        enabled: !!user,
        retry: false,
    });
    const cartId = cartIdResponse?.cartId;
    const { data: cart, isFetching: cartFetching } = useQuery({
        ...queries.cart.detail(shopId, cartId!),
        enabled: !!cartId,
    });
    const isFetching = idFetching || cartFetching;
    const isBlank = !isFetching && !cart;
    return {
        isFetching,
        cart,
        isBlank,
    };
}

export default useCart;
